import { render, staticRenderFns } from "./trouble-chats-not-restoring.vue?vue&type=template&id=0ab92bbe"
import script from "./trouble-chats-not-restoring.vue?vue&type=script&lang=js"
export * from "./trouble-chats-not-restoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports